import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography } from "@mui/material";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import DesempenhoDistribuidor from "./components/DesempenhoDistribuidor";
import Cobertura from "./components/Cobertura";
import Oportunidade from "./components/Oportunidade";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function ClienteDesktop({ app }) {
  const { isLoading } = useOverviewData(app);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2} sx={{ marginTop: "37px" }}>
                {/* First row - 2 columns */}
                <Grid item xs={12}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} md={8}>
                  <OverviewCardSkeleton variant="retangle" />
                </Grid>
                <Grid item xs={12} md={4}>
                  <OverviewCardSkeleton variant="retangle" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginTop: "37px" }}>
                <Box className="container-card-title">
                  <Typography variant="h1" className="title">
                    Cobertura Qualificada - Cliente
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} className="container-tables-tops">
                    <DesempenhoDistribuidor app={app} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8} className="container-tables-tops">
                    <Cobertura app={app} />
                  </Grid>
                  <Grid item xs={12} md={4} className="container-tables-tops">
                    <Oportunidade app={app} />
                  </Grid>
                </Grid>

                  <Footer app={app} customClass={"footer-cliente"}/>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

ClienteDesktop.propTypes = {
  app: PropTypes.object,
};

export default ClienteDesktop;
